import { EmailService } from './email.service';

export { EmailService } from './email.service';

export const services = [EmailService];
